import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const ApiDocsPage = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        // Create iframe with Swagger UI
        const iframe = document.getElementById('swagger-iframe') as HTMLIFrameElement;
        if (iframe) {
            const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5010';

            // Direct access to Swagger UI (no token needed in development)
            iframe.src = `${apiUrl}/api-docs`;

            iframe.onload = () => {
                setLoading(false);
            };

            iframe.onerror = () => {
                setError('Erreur lors du chargement de la documentation');
                setLoading(false);
            };
        }
    }, []);

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <Typography variant="h6" color="error" sx={{ fontFamily: 'Quicksand, sans-serif' }}>
                    {error}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', height: '100vh', position: 'relative' }}>
            {loading && (
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2
                }}>
                    <CircularProgress />
                    <Typography variant="body1" sx={{ fontFamily: 'Quicksand, sans-serif' }}>
                        Chargement de la documentation API...
                    </Typography>
                </Box>
            )}
            <iframe
                id="swagger-iframe"
                title="API Documentation"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: loading ? 'none' : 'block'
                }}
            />
        </Box>
    );
};

export default ApiDocsPage;
